import type {TextDocumentResponse} from "@mytour/shared";
import {useState} from "react";
import {DocumentCardChrome} from "./DocumentCardChrome";
import {DocumentTile} from "./DocumentTile";
import {NoteLightbox} from "./NoteLightbox";

type Props = {
  doc: TextDocumentResponse;
};

const NOTE_BADGE_COLOR = "#0d6dfd42";

export function NoteCard({doc}: Props) {
  const [open, setOpen] = useState(false);

  return (
    <DocumentCardChrome>
      <div
        role="button"
        tabIndex={0}
        onClick={handleOpen}
        onKeyDown={handleKeyDown}
        style={{cursor: "pointer"}}
      >
        <DocumentTile
          thumb={{kind: "badge", label: "NOTE", color: NOTE_BADGE_COLOR}}
          title=""
          subtitle={doc.body}
          subtitleClamp={2}
        />
      </div>
      <NoteLightbox doc={doc} open={open} onToggle={handleToggle} />
    </DocumentCardChrome>
  );

  function handleOpen() {
    setOpen(true);
  }

  function handleToggle() {
    setOpen((v) => !v);
  }

  function handleKeyDown(event: React.KeyboardEvent<HTMLDivElement>) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      setOpen(true);
    }
  }
}
